import type { ThemePreference } from '../../electron-shared/app-settings/app-settings-schema';

export type ThemeSyncAction =
  | { type: 'none' }
  | { type: 'apply'; preference: ThemePreference }
  | { type: 'save'; preference: ThemePreference };

export const resolveThemeSyncAction = ({
  sharedPreference,
  localPreference,
  lastSyncedPreference,
}: {
  sharedPreference: ThemePreference | null;
  localPreference: ThemePreference;
  lastSyncedPreference: ThemePreference | null;
}): ThemeSyncAction => {
  if (sharedPreference && sharedPreference !== lastSyncedPreference) {
    return { type: 'apply', preference: sharedPreference };
  }

  if (localPreference !== lastSyncedPreference) {
    return { type: 'save', preference: localPreference };
  }

  return { type: 'none' };
};
